import {createSelector} from 'reselect'
import {getPatientsStoreState} from "../../store/patients-selectors";

export class PatientsRawTemperatureSelectors {
    static readonly state = createSelector(getPatientsStoreState, state => state.temperature);
    static readonly loading = createSelector(PatientsRawTemperatureSelectors.state, state => state.loading);
    static readonly error = createSelector(PatientsRawTemperatureSelectors.state, state => state.error);
}

